<template>
  <div
    id="chart-demo"
    class="white pa-5"
    :style="{ borderRadius: '5%' }"
  >
    <v-card class="mb-5" outlined>
      <v-card-title>
        <strong>Comparativas semanales</strong>
      </v-card-title>

      <v-card-text>
        <div class="row">


          <div class="col-12 col-md-5 mb-3">
            <label for="primerSemana">
              Seleccione un día para la primera semana (se sumarán 7 días)
            </label>
            <date-picker id="primerSemana"
              v-model="start"
              :value="start"
              @dateSelected="(startP) => { start = startP }"
            />
          </div>

          <div class="col-12 col-md-5 mb-3">
            <label for="segundaSemana">
              Seleccione un día para la segunda semana (se sumarán 7 días)
            </label>
            <date-picker
              v-model="end"
              :value="end"
              @dateSelected="(endP) => (end = endP)"
            />
          </div>

          <div class="col-12 col-md-2">
            <div class="d-flex align-center h-100 mt-4">
              <DxButton
              text="Aplicar"
              type="default"
              styling-mode="contained"
              @click="getTopProductsRange()"
              />
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <div class="col-12">
      <spinner v-if="loadData" />

      <DxChart
        v-else
        id="chart"
        :data-source="sharingStatisticsInfo"
        :palette="['#7986CB','#AED581']"
        title="Comparación de la semana actual y la anterior"
      >
        <DxCommonSeriesSettings
          :type="type"
          argument-field="dia"
        />

        <DxCommonAxisSettings>
          <DxGrid :visible="true" />
        </DxCommonAxisSettings>

        <DxSeries
          v-for="serie in architectureSources"
          :key="serie.value"
          :value-field="serie.value"
          :name="serie.name"
        />

        <DxLegend
          vertical-alignment="top"
          horizontal-alignment="right"
        />

        <DxTooltip
          :enabled="true"
          :customize-tooltip="customTooltip"
        />
      </DxChart>
    </div>

  </div>
</template>

<script>
import {
  DxChart,
  DxSeries,
  //DxArgumentAxis,
  DxCommonSeriesSettings,
  DxCommonAxisSettings,
  DxGrid,
  //DxExport,
  DxLegend,
  //DxMargin,
  DxTooltip,
  //DxLabel,
  //DxFormat,
} from "devextreme-vue/chart";
import DxButton from "devextreme-vue/button";
import DatePicker from "../../components/DatePicker";
import moment from "moment";
import spinner from "./spinner.vue";

/* import DxSelectBox from 'devextreme-vue/select-box'; */

/* import { architectureSources, sharingStatisticsInfo } from './data.js'; */
/* import moment from 'moment'; */
export default {
  components: {
    /*  DxSelectBox, */
    DxChart,
    DxSeries,
    //DxArgumentAxis,
    DxCommonSeriesSettings,
    DxCommonAxisSettings,
    DxGrid,
    //DxExport,
    DxLegend,
    //DxMargin,
    DxTooltip,
    DxButton,
    //DxLabel,
    //DxFormat,
    DatePicker,
    spinner
  },
  props:{
    branch:{
      type:Number,
      default: 0,
    },
    ambiente:{
      type:Number,
      default: 1,
    },
    autoLoad: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      start: moment().format("DD/MM/YYYY"),
      end: moment().format("DD/MM/YYYY"),
      sharingStatisticsInfo: [],
      architectureSources: [],
      types: ["spline", "stackedspline", "fullstackedspline"],
      type: "spline",
      loadData: false,
    };
  },
  watch: {
    branch(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getTopProductsRange();
      }
    }
  },
  mounted() {
    let currentWeek = moment().subtract(1, "weeks").format("DD/MM/YYYY");
    let previousWeek = moment().subtract(2, "weeks").format("DD/MM/YYYY");

    this.start = previousWeek;
    this.end = currentWeek;
    this.architectureSources = [
      { value: "actual", name: "primer Semana" },
      { value: "anterior", name: "segunda semana" },
    ];

    //this.getLineData();
    if (this.autoLoad) {
      this.getTopProductsRange();
    }
  },
  methods: {
    transformDay(data) {
      if (data) {
        data.forEach((element) => {
          switch (element.day) {
            case "Sunday":
              element.day = "Domingo";
              break;
            case "Monday":
              element.day = "Lunes";
              break;
            case "Tuesday":
              element.day = "Martes";
              break;
            case "Wednesday":
              element.day = "Miércoles";
              break;
            case "Thursday":
              element.day = "Jueves";
              break;
            case "Friday":
              element.day = "Viernes";
              break;
            case "Saturday":
              element.day = "Sábado";
              break;
            default:
              break;
          }
        });
        return data;
      } else {
        return null;
      }
    },
    getLineData() {
      this.$API.dashboard.LineWeek().then((response) => {
        this.sharingStatisticsInfo = this.transformDay(response);
      });
    },
    getTopProductsRange() {
      this.loadData = true;
      const params = {
        start: new Date(this.formatDate(this.start)),
        end: new Date(this.formatDate(this.end)),
        branch: this.branch,
        ambiente: this.ambiente,
      }
      return this.$API.dashboard
        .getWeeksCustom(
          params
        )
        .then((response) => {
          this.sharingStatisticsInfo = this.normalizeWeekData(response);
          console.log(this.sharingStatisticsInfo);
          this.architectureSources = [
            { value: 'semana1', name: 'Primer Semana' },
            { value: 'semana2', name: 'Segunda Semana' }
          ];
        }).finally(()=> this.loadData = false);
    },
    normalizeWeekData(data) {
      const daysMap = {};
      data.forEach(item => {
        const day = item.DiaSemana; 
        if (!daysMap[day]) {
          daysMap[day] = {
            dia: day,
            semana1: 0,
            semana2: 0,
            fechaSemana1: null,
            fechaSemana2: null,
          };
        }
        if (item.NumeroSemana === 1) {
          daysMap[day].semana1 += Number(item.TotalPriceNotIva);
          daysMap[day].fechaSemana1 = item.Fecha;
        }
        if (item.NumeroSemana === 2) {
          daysMap[day].semana2 += Number(item.TotalPriceNotIva);
          daysMap[day].fechaSemana2 = item.Fecha;
        }
      });

      return Object.values(daysMap);
    },
    customTooltip(info) {
      const data = info.point.data;
      const isSemana1 = info.seriesName === 'Primer Semana';

      const baseValue = data.semana1;
      const compareValue = data.semana2;

      let porcentaje = null;

      if (baseValue > 0) {
        porcentaje = ((compareValue - baseValue) / baseValue) * 100;
      }

      const fechaRaw = isSemana1 ? data.fechaSemana1 : data.fechaSemana2;

      let formattedDate = '';
      if (fechaRaw) {
        const date = this.parseLocalDate(fechaRaw);
        formattedDate = date.toLocaleDateString('es-SV', {
          day: '2-digit',
          month: '2-digit'
        });
      }

      const amount = info.value.toLocaleString('es-SV', {
        style: 'currency',
        currency: 'USD'
      });

      let variacionHtml = '';

      if (!isSemana1 && porcentaje !== null && isFinite(porcentaje)) {
        const isPositive = porcentaje >= 0;
        const sign = isPositive ? '+' : '';
        const color = isPositive ? '#2e7d32' : '#c62828';
        const arrow = isPositive ? '▲' : '▼';

        variacionHtml = `
          <div>
              <strong>Variación:</strong> 
              <span style="color:${color}; font-weight:600;">
                ${arrow} ${sign}${porcentaje.toFixed(2)}%
              </span>
          </div>
        `;
      }

      return {
        html: `
          <div style="min-width:160px;">
            <div style="font-weight:600; margin-bottom:4px;">
              ${data.dia} ${formattedDate}
            </div>
            <div style="margin-bottom:4px;">
              ${amount}
            </div>
            ${variacionHtml}
          </div>
        `
      };
    },
    parseLocalDate(dateStr) {
      const [year, month, day] = dateStr.split('-');
      return new Date(year, month - 1, day);
    },
    formatDate(date) {
      const parts = date.split("/");
      const aux = parts[0];
      parts[0] = parts[1];
      parts[1] = aux;
      return parts.join("/");
    },
  },
};
</script>
<style>
.options {
  padding: 20px;
  background-color: rgba(191, 191, 191, 0.15);
  margin-top: 20px;
}

.option {
  margin-top: 10px;
}

.caption {
  font-size: 18px;
  font-weight: 500;
}

.option > span {
  margin-right: 14px;
}

.option > .dx-widget {
  display: inline-block;
  vertical-align: middle;
}
</style>
